import { useApiClient } from '../../client'
import { BOOKSY_PAY_SETTINGS_ENDPOINT } from '../consts.ts'
import type { BooksyPaySettingsResponse } from '../types'

export function getBooksyPaySettings (businessId) {
  const apiClient = useApiClient()

  return apiClient.get<BooksyPaySettingsResponse>({
    url: BOOKSY_PAY_SETTINGS_ENDPOINT,
    urlParams: {
      businessId,
    },
  })
}
